export default __webpack_public_path__ + "static/media/마크라메_웹.8aedde07.jpg";